<template>
  <v-sheet color="grey lighten-4 width-100 height-100 pa-4" rounded>
    <div class="d-flex flex-column height-100">
      <div class="mb-2 d-flex align-center">
        <h3 class="text-subtitle-1 font-weight-medium mr-3 mb-0">Build & Debug</h3>
        <v-spacer></v-spacer>
        <v-btn small color="primary" :disabled="!game || isBuilding" @click="triggerBuild">
          <v-icon left>mdi-hammer-wrench</v-icon>
          {{ isBuilding ? 'Building…' : 'Build' }}
        </v-btn>
      </div>

      <div>
        <div v-if="builds.length === 0" class="caption grey--text">No builds yet. Click Build to start.</div>

        <v-list two-line dense>
          <v-list-item v-for="b in builds" :key="b.id">
            <v-list-item-content>
              <v-list-item-title>
                <v-chip :color="statusColor(b.status)" small class="white--text mr-2">{{ b.status }}</v-chip>
                <span class="font-weight-medium">Build {{ b.id.slice(0,6) }}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span v-if="b.errors && b.errors.length" class="error--text">Errors: {{ b.errors.join('; ') }}</span>
                <span v-else-if="b.warnings && b.warnings.length" class="warning--text">Warnings: {{ b.warnings.join('; ') }}</span>
                <span v-else>OK</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon :disabled="!b.artifactUrl">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { collection, query, where, orderBy, limit, onSnapshot, addDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/init';

export default {
  name: 'GameDebug',
  props: {
    game: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      builds: [],
      isBuilding: false,
      unsubscribe: null
    };
  },
  methods: {
    statusColor(status) {
      switch ((status || '').toLowerCase()) {
        case 'success': return 'green';
        case 'running': return 'blue';
        case 'failed': return 'red';
        default: return 'grey';
      }
    },
    listenBuilds() {
      if (!this.game || !this.game.id) return;
      const buildsRef = collection(db, 'builds');
      const q = query(buildsRef, where('gameId', '==', this.game.id), orderBy('createdAt', 'desc'), limit(5));
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = onSnapshot(q, (snap) => {
        this.builds = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      });
    },
    async triggerBuild() {
      try {
        this.isBuilding = true;
        const region = 'us-central1';
        const projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID || (window && window.firebase && window.firebase.app ? window.firebase.app().options.projectId : 'ideaverse-development');
        const url = `https://${region}-${projectId}.cloudfunctions.net/buildGame`;
        const resp = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ gameId: this.game.id }) });
        if (!resp.ok) {
          const t = await resp.text();
          console.warn('Build failed', t);
        }
      } catch (e) {
        console.error('triggerBuild error', e);
      } finally {
        this.isBuilding = false;
      }
    }
  },
  watch: {
    game: {
      handler() { this.listenBuilds(); },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  }
};
</script>

<style scoped>
</style>


